export function generateCartSessionId() {
  // Format: cart_<timestamp>_<random>
  return (
    "cart_" +
    Date.now().toString(36) +
    "_" +
    Math.random().toString(36).substring(2, 11)
  );
}

export function getCartSessionId() {
  let sessionId = localStorage.getItem("cart_session_id");

  // Generate new ID if doesn't exist
  if (!sessionId) {
    sessionId = generateCartSessionId();
    localStorage.setItem("cart_session_id", sessionId);
  }

  return sessionId;
}

export function clearCartSession() {
  localStorage.removeItem("cart_session_id");
}
